import { ListGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import type { RootState } from 'store';

interface LeadSourceItemProps {
  serial: number;
  source: string;
  count: number;
}

const LeadSources = () => {
  // Get dynamic data from Redux store
  const users = useSelector((state: RootState) => state.users.data);
  const assets = useSelector((state: RootState) => state.assets.data);

  // Calculate user device counts
  const userDeviceCounts = users.map(user => {
    const userAssets = assets.filter(
      asset => asset.current_holder_id === user.id
    );
    return {
      id: user.id,
      name: user.name,
      deviceCount: userAssets.length
    };
  });

  // Sort users by device count (descending) and take top 5
  const topUsers = userDeviceCounts
    .sort((a, b) => b.deviceCount - a.deviceCount)
    .slice(0, 5);

  return (
    <ListGroup variant="flush">
      {topUsers.map((user, index) => (
        <LeadSourceItem
          key={user.id}
          serial={index + 1}
          source={user.name}
          count={user.deviceCount}
        />
      ))}
      {topUsers.length === 0 && (
        <ListGroup.Item className="bg-transparent list-group-crm fw-bold text-body fs-9 py-2">
          <div className="d-flex justify-content-between">
            <span className="fw-normal fs-9 mx-1">
              No users with devices found
            </span>
          </div>
        </ListGroup.Item>
      )}
    </ListGroup>
  );
};

const LeadSourceItem = ({ serial, source, count }: LeadSourceItemProps) => {
  return (
    <ListGroup.Item className="bg-transparent list-group-crm fw-bold text-body fs-9 py-2">
      <div className="d-flex justify-content-between">
        <span className="fw-normal fs-9 mx-1">
          <span className="fw-bold">{serial}.</span> {source}
        </span>{' '}
        <span>({count})</span>
      </div>
    </ListGroup.Item>
  );
};

export default LeadSources;
